import React from "react";
import UserMessage from "../UserMessage";
import ServerMessage from "./ServerMessage";
import DefaultCard from "./DefaultCard";

const MessageRenderer = ({ type, content, suggestionKey, citations, isStreaming, onRegenerate, onEdit }) => {
    if (type === "user") {
        return <UserMessage content={content} onEdit={onEdit} />;
    }

    if (type === "server") {
        if (!content && !isStreaming) {
            return null;
        }

        if (content === DefaultCard) {
            return ;
        }

        return (
            <ServerMessage
                content={content}
                suggestionKey={suggestionKey}
                citations={citations}
                isStreaming={isStreaming}
                onRegenerate={onRegenerate}
            />
        );
    }

    return null;
};

export default MessageRenderer;
